import { Flex, HStack, Icon, IconButton, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiChevronLeft, FiChevronRight, FiRepeat } from "react-icons/fi";
import type { NegotiationRoundDto } from "../../../autogen/bff-api";
import { NegotiationRoundStatusTag } from "../negotiation/NegotiationRoundStatusTag";
import { useRoundSelection } from "./RoundSelectionContext";
import { stageLabel } from "./stageLabel";

export const RoundPager = ({ justify = "center" }: { justify?: "center" | "flex-start" }) => {
  const { t } = useTranslation();
  const { rounds, selectedRound, selectRound } = useRoundSelection();
  if (rounds.length === 0) return null;

  const stages: (NegotiationRoundDto | null)[] = [null, ...rounds];
  const index = selectedRound ? stages.findIndex((stage) => stage?.id === selectedRound.id) : 0;
  const label = stageLabel(t, selectedRound);

  return (
    <Flex align="center" justify={justify} gap="1" py="1">
      <IconButton
        aria-label={t("Previous round") ?? "Previous round"}
        icon={<Icon as={FiChevronLeft} />}
        size="sm"
        variant="ghost"
        colorScheme="teal"
        isDisabled={index <= 0}
        onClick={() => selectRound(stages[index - 1])}
      />
      <HStack spacing="2" px="2">
        <Icon as={FiRepeat} color="smMuted" boxSize="3.5" />
        <Text fontWeight="semibold" fontSize="sm">
          {label}
        </Text>
        {selectedRound && <NegotiationRoundStatusTag status={selectedRound.status} />}
      </HStack>
      <IconButton
        aria-label={t("Next round") ?? "Next round"}
        icon={<Icon as={FiChevronRight} />}
        size="sm"
        variant="ghost"
        colorScheme="teal"
        isDisabled={index >= stages.length - 1}
        onClick={() => selectRound(stages[index + 1])}
      />
    </Flex>
  );
};
